export default __webpack_public_path__ + "static/media/exploracioncomercial.84d4175f.svg";